import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import {
  Game,
  GameCollection,
  GameCollectionJson,
  GameJson,
  GameStatistics,
  GameStatisticsJson,
  jsonToGame,
} from '../GameStore';
import { GameRecord, GameRecordJson } from '../RecordStore';
import { RepositoryElement } from '../Repository';

export interface PerformanceGameJson<T = number> {
  gameRecord: GameRecordJson<T>;
  game: GameJson<T>;
  gameStatistics: GameStatisticsJson;
  gameCollection: GameCollectionJson<T>;
}

export class PerformanceGame
  extends RepositoryElement
  implements PerformanceGameJson<Date>
{
  gameRecord!: GameRecord;
  game!: Game;
  gameStatistics!: GameStatistics;
  gameCollection!: GameCollection;

  constructor(performanceGame: PerformanceGameJson<Date | number>) {
    super();
    const { gameRecord, game, gameStatistics, gameCollection, ...rest } =
      deepTransformTimestamp(performanceGame);
    this.gameRecord = new GameRecord(gameRecord);
    this.game = jsonToGame(game);
    this.gameStatistics = new GameStatistics(gameStatistics);
    this.gameCollection = new GameCollection(gameCollection);
    Object.assign(this, rest);
  }

  id(): string {
    return this.gameRecord.gameRecordId;
  }

  toJSON(): PerformanceGameJson {
    return deepTransformDate(this) as unknown as PerformanceGameJson;
  }
}
